export default "__VITE_ASSET__DVPjYgTU__"